import dayjs from "dayjs";

import LeadTimeHelper from "@shared/helper/LeadTimeHelper";
import { DELIVERY_METHOD, DATE_FORMATS } from "@shared/constants";

const leadTimeHelper = new LeadTimeHelper();

/**
 * Returns entire lead time object (for both home delivery and dealer delivery)
 *
 * @param { Object } deal
 *
 * @return {{
 *   leadTime: number,
 *   leadTimeHomeDelivery: number,
 *   leadTimeDate: string,
 *   leadTimeHomeDeliveryDate: string
 * }}
 */
export function getLeadTimeInfo({ carConfiguration, userProfile }) {
  const activeCarPreconfiguration = carConfiguration.preconfiguration;
  const activeAccessory = carConfiguration.accessory;
  const isHomeDelivery =
    userProfile.deliveryData?.type === DELIVERY_METHOD.HOME ?? false;
  const activeAccessoryIds = activeAccessory.map(accessory => accessory.id);

  return leadTimeHelper.calculateLeadTime(
    activeCarPreconfiguration,
    activeAccessoryIds,
    isHomeDelivery
  );
}

/**
 * Returns the correct leadtime depending on delivery method selected
 *
 * @param { Object } deal
 *
 * @return {{leadTime: number, leadTimeDate: string}}
 */
export function getFinalLeadTimeInfo({ carConfiguration, userProfile }) {
  const isHomeDelivery =
    userProfile.deliveryData?.type === DELIVERY_METHOD.HOME ?? false;

  const leadTime = getLeadTimeInfo({ carConfiguration, userProfile });

  return isHomeDelivery
    ? {
        leadTime: leadTime.leadTimeHomeDelivery,
        leadTimeDate: leadTime.leadTimeHomeDeliveryDate,
      }
    : {
        leadTime: leadTime.leadTime,
        leadTimeDate: leadTime.leadTimeDate,
      };
}

/**
 * Get maximum delivery date
 * Function gets maxLeadTimes for each delivery method and returns formatted leadTime
 * based on seletedDeliveryMethod. Returned Date is always formatted to be
 * next Monday from maximumLeadTime
 *
 * @param deal
 * @returns {Date}
 */
export function getExpectedDeliveryDate(deal) {
  const { leadTimeDate, leadTimeHomeDeliveryDate } = getLeadTimeInfo(deal);

  const isHomeDelivery =
    deal.userProfile.deliveryData?.type === DELIVERY_METHOD.HOME ?? false;

  // These are already dates of the next monday (that's how they are generated during import)
  const expectedDeliveryDate = isHomeDelivery
    ? leadTimeHomeDeliveryDate
    : leadTimeDate;

  const expectedDeliveryFullDate = dayjs(expectedDeliveryDate).format(
    DATE_FORMATS.TO_SECOND_SLASH
  );

  return new Date(expectedDeliveryFullDate);
}
